export const CC_VALUE_KEY = 'cc_default_value';
